<template>
  <img
    :src="branding.logo"
    :style="branding.logostyle"
    :alt="branding.name"
    id="site-logo"
  />
</template>
<style></style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "site-logo",
  computed: {
    ...mapGetters("core", ["branding"])
  }
};
</script>
